// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1kju3","range":"MonthRangeSwitch_range__bxf_f","disabled":"MonthRangeSwitch_disabled__2vbh9"};